import { configureStore } from '@reduxjs/toolkit';
import { supportSlice } from 'features/_Support/store';
import { adminsEditAdminSlice } from 'features/Admins/EditAdmin/store';
import { adminsLisAdminsSlice } from 'features/Admins/ListAdmins/store';
import { coachCombinedAvailabilitySlice } from 'features/Bookings/CoachCombinedAvailability/store';
import { bookingsEditBookingSlice } from 'features/Bookings/EditBooking/store';
import { facilityUsageSlice } from 'features/Bookings/FacilityUsage/store';
import { bookingsListBlackoutsSlice } from 'features/Bookings/ListBlackouts/store';
import { bookingsListBookingsActiveSlice } from 'features/Bookings/ListBookingsActive/store';
import { bookingsNewBookingSlice } from 'features/Bookings/NewBooking/store';
import { clubhousesEditClubhouseSlice } from 'features/Clubhouses/EditClubhouse/store';
import { clubhousesListClubhousesSlice } from 'features/Clubhouses/ListClubhouses/store';
import { clubhouseStaffEditClubhouseStaffSlice } from 'features/ClubhouseStaff/EditClubhouseStaff/store';
import { clubhouseStaffListClubhouseStaffSlice } from 'features/ClubhouseStaff/ListClubhouseStaff/store';
import { coachesEditCoachSlice } from 'features/Coaches/EditCoach/store';
import { coachesListCoachesSlice } from 'features/Coaches/ListCoaches/store';
import { membersEditMemberSlice } from 'features/Members/EditMember/store';
import { membersEditPackageSlice } from 'features/Members/EditPackage/store';
import { membersListLessonNoteMembersSlice } from 'features/Members/ListLessonNoteMembers/store';
import { membersListLessonNotesSlice } from 'features/Members/ListLessonNotes/store';
import { membersListMembersSlice } from 'features/Members/ListMembers/store';
import { membersListPackagesSlice } from 'features/Members/ListPackagesActive/store';
import { membersListSubscriptionsSlice } from 'features/Members/ListSubscriptions/store';
import { membershipTypesEditMembershipTypeSlice } from 'features/MembershipTypes/EditMembershipType/store';
import { myAccountSlice } from 'features/MyAccount/store';
import { notificationsEditNotificationSlice } from 'features/Notifications/EditNotification/store';
import { notificationsListNotificationsSlice } from 'features/Notifications/ListNotifications/store';
import { notificationsNewNotificationSlice } from 'features/Notifications/NewNotification/store';
import { productsAddPackageSlice } from 'features/Products/AddPackage/store';
import { productsListProductsSlice } from 'features/Products/ListProducts/store';
import { dataExportSlice } from 'features/Report/DataExport/store';
import { reportListAcTransactionsSlice } from 'features/Report/ListAcTransactions/store';
import { reportListHitPayChargesSlice } from 'features/Report/ListHitPayCharges/store';
import { reportListInvoicesSlice } from 'features/Report/ListInvoices/store';
import { shopSlice } from 'features/Shop/store';
import { useDispatch } from 'react-redux';
import { authSlice } from './auth';
import { managementSystemSlice } from './management-system';
import { uiSlice } from './ui';

export const store = configureStore({
  devTools: true,
  reducer: {
    adminsEditAdmin: adminsEditAdminSlice.reducer,
    adminsListAdmins: adminsLisAdminsSlice.reducer,
    auth: authSlice.reducer,
    bookingsEditBooking: bookingsEditBookingSlice.reducer,
    bookingsListBlackouts: bookingsListBlackoutsSlice.reducer,
    bookingsListBookingsActive: bookingsListBookingsActiveSlice.reducer,
    bookingsNewBooking: bookingsNewBookingSlice.reducer,
    clubhouseStaffEditClubhouseStaff:
      clubhouseStaffEditClubhouseStaffSlice.reducer,
    clubhouseStaffListClubhouseStaff:
      clubhouseStaffListClubhouseStaffSlice.reducer,
    clubhousesEditClubhouse: clubhousesEditClubhouseSlice.reducer,
    clubhousesListClubhouses: clubhousesListClubhousesSlice.reducer,
    coachCombinedAvailability: coachCombinedAvailabilitySlice.reducer,
    coachesEditCoach: coachesEditCoachSlice.reducer,
    coachesListCoaches: coachesListCoachesSlice.reducer,
    dataExport: dataExportSlice.reducer,
    facilityUsage: facilityUsageSlice.reducer,
    managementSystem: managementSystemSlice.reducer,
    membersEditMember: membersEditMemberSlice.reducer,
    membersEditPackage: membersEditPackageSlice.reducer,
    membersListLessonNoteMembers: membersListLessonNoteMembersSlice.reducer,
    membersListLessonNotes: membersListLessonNotesSlice.reducer,
    membersListMembers: membersListMembersSlice.reducer,
    membersListPackages: membersListPackagesSlice.reducer,
    membersListSubscriptions: membersListSubscriptionsSlice.reducer,
    membershipTypesEditMembershipType:
      membershipTypesEditMembershipTypeSlice.reducer,
    myAccount: myAccountSlice.reducer,
    notificationsEditNotification: notificationsEditNotificationSlice.reducer,
    notificationsListNotifications: notificationsListNotificationsSlice.reducer,
    notificationsNewNotification: notificationsNewNotificationSlice.reducer,
    productsAddPackage: productsAddPackageSlice.reducer,
    productsListProducts: productsListProductsSlice.reducer,
    reportListAcTransactions: reportListAcTransactionsSlice.reducer,
    reportListHitPayCharges: reportListHitPayChargesSlice.reducer,
    reportListInvoices: reportListInvoicesSlice.reducer,
    shop: shopSlice.reducer,
    support: supportSlice.reducer,
    ui: uiSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch();
